// ─── Game promo footer rotation ───────────────────────────────────
//
// V42.1: shows a small "→ Try {GameName} ({Family})" line in tool
// footers. Family-weighted: a tool in family X picks from games of
// family X most of the time, occasionally surfaces a cross-family game.
//
// V44: GAMES list now imported from src/games/registry.js (the canonical
// game registry). Single source of truth — adding a game to the registry
// makes it eligible for promo rotation automatically, with the correct
// new-family URL.
//
// Weighting (Ian, 2026-05-20): in-family games favored, but only slightly
// above cross-family. Default 70/30.

import { GAMES as REGISTRY_GAMES } from "../games/registry.js";

export const FAMILY_WEIGHT = 0.7;  // probability of picking in-family

// Use the canonical registry. The registry's shape already matches what
// pickGamePromo needs: { id, name, family, path, tagline }.
export const GAMES = REGISTRY_GAMES;

// Pick a game to promote. `currentFamily` = the family of the tool the
// user is viewing. Returns one game, picked with FAMILY_WEIGHT probability
// from the in-family pool, otherwise from the rest.
//
// Edge cases handled honestly:
//   - No games in current family → falls through to cross-family.
//   - No games at all → returns null (caller renders nothing).
//   - Only games are in current family → in-family pool is whole pool;
//     weight calc still works but cross branch never fires.
//
// `excludeId` lets a caller hide a specific game (e.g. don't promote
// PeriodicQuest from inside PeriodicQuest itself).
export function pickGamePromo(currentFamily, excludeId = null) {
  const all = GAMES.filter((g) => g.id !== excludeId);
  if (all.length === 0) return null;

  const inFamily = currentFamily ? all.filter((g) => g.family === currentFamily) : [];
  const outFamily = currentFamily ? all.filter((g) => g.family !== currentFamily) : all;

  if (inFamily.length === 0) {
    return outFamily[Math.floor(Math.random() * outFamily.length)];
  }
  if (outFamily.length === 0) {
    return inFamily[Math.floor(Math.random() * inFamily.length)];
  }

  if (Math.random() < FAMILY_WEIGHT) {
    return inFamily[Math.floor(Math.random() * inFamily.length)];
  }
  return outFamily[Math.floor(Math.random() * outFamily.length)];
}
